export const ID_QUERY = `
  sys {
    id
  }
`;

export interface CommonRes {
  sys: {
    id: string;
  };
}
